import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getStorage } from '@/utils/storage'
import { COMPANY_SHORT_NAME } from '@/constants'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login'] // whitelist

router.beforeEach(async (to, from, next) => {
  NProgress.start() // start progress bar

  document.title = `${COMPANY_SHORT_NAME}-运营管理后台` // set page title

  const hasToken = getStorage('token') // login token

  if (hasToken) {
    if (to.path === '/login') { // if is logged in, redirect to the home page
      next({ path: '/userManage' })
      NProgress.done()
    } else {
      next()
      NProgress.done()
    }
  } else { // not token
    if (whiteList.indexOf(to.path) !== -1) { // in the free login whitelist, go directly
      next()
    } else { // must login
      next(`/login`)
      NProgress.done()
    }
  }
})

router.afterEach(() => { // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js